import React from 'react';
import LayoutA from '../../../../dumb/Layout/A';
import {AdminTabs} from "../../../../dumb/Tabs";
import {VertoTableInitiated, VertoTableInitiatedTests} from "./components/VertoTableInitiated";
import {VertoTableCompleted} from "./components/VertoTableCompleted";

module.exports = () => {
  const tabsData = {
    initiated: {
      title: 'Initiated Payouts',
      component: VertoTableInitiated
    },
    completed: {
      title: 'Completed Payouts',
      component: VertoTableCompleted
    },
    initiatedTests: {
      title: 'Initiated Payouts | TESTS',
      component: VertoTableInitiatedTests
    },
  };

  return (
    <LayoutA>
      <AdminTabs
        tabsEmitterName="type"
        tabsData={tabsData}
      />
    </LayoutA>
  )
};
